export default "__VITE_ASSET__CQVnkl21__"